// Список доступных городов
export const AVAILABLE_CITIES = [
  'Ташкент',
  'Андижан',
  'Наманган',
  'Бухара',
  'Фергана',
  'Коканд',
  'Карши',
  'Самарканд',
  'Хива',
  'Ургенч',
  'Термез',
  'Денау',
  'Гулистан',
  'Навои',
  'Нукус',
  'Джизак',
  'Регионы'
];

export const CITY_OPTIONS = AVAILABLE_CITIES.map(city => ({
  value: city,
  label: city
}));

